import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";

const ConfiguracionBasica = (props) => {
    return (
        <div>
            <div className="row">

                <CheckboxSection message={"Controlar la cantidad máxima de ingresos incorrectos consecutivos de la contraseña: "}
                    subMessage="Alcanzada la cantidad máxima de intentos, el usuario será bloqueado. "
                    isChecked={props.cantIntentosFallidos != null}
                    id={props.id}
                    value={props.cantIntentosFallidos}
                    extencion=" intentos" />

                <CheckboxSection message={"Controlar el tiempo de vigencia de la contraseña para un usuario: "}
                    subMessage="Alcanzada la cantidad máxima de días, el usuario deberá cambiar la contraseña. "
                    isChecked={props.maxDiasCaducidad != null}
                    id={props.id}
                    value={props.maxDiasCaducidad}
                    extencion=" días" />

                <CheckboxSection message={"Controlar el tiempo máximo sin que el usuario inicie sesión: " }
                    subMessage="Alcanzada la cantidad máxima de días, el usuario será bloqueado. "
                    isChecked={props.maxDiasInactividad != null}
                    id={props.id}
                    value={props.maxDiasInactividad}
                    extencion=" días" />

                <CheckboxSection message={"Permitir que una sesión permanezca abierta sin que el usuario esté operando: "}
                    subMessage="Una vez que haya terminado el tiempo definido se cerrará la sesión."
                    isChecked={props.minutosPermitidosInactividad != null}
                    id={props.id}
                    value={props.minutosPermitidosInactividad}
                    extencion=" minutos"/>

                <CheckboxSection message={"Guardar las últimas contraseñas utilizadas por el usuario: "}
                    isChecked={props.cantidadRepeticiones != null}
                    id={props.id}
                    value={props.cantidadRepeticiones}
                    extencion=" contraseña/s"/>
            </div>

            
        </div>
    );
};

export default ConfiguracionBasica;
